interface TruncateStringArgs {
  value: string;
  maxLength: number;
}

export const truncateString = ({ value, maxLength }: TruncateStringArgs) =>
  value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
